import component from './popupTips'

const com = {
  install (Vue) {
    Vue.component('popupTips', component)
  }
}
export default com
